/**
 * @owner @Appboy/in-app-messages
 */

// generated from 2_281_449 samples

import { z } from "zod";

export const colorSchema = z.object({
  // integer: 2_189_607 (95.97%)
  // avg: 0.77, min: 0, max: 1
  a: z.number().min(0).max(1),
  // avg: 44.50, min: 0, max: 255
  b: z.int().min(0).max(255),
  // avg: 40.01, min: 0, max: 255
  g: z.int().min(0).max(255),
  // avg: 32.95, min: 0, max: 255
  r: z.int().min(0).max(255),
});
